import { render, staticRenderFns } from "./RemoteSearch.vue?vue&type=template&id=7bb350cc&scoped=true&"
import script from "./RemoteSearch.vue?vue&type=script&lang=js&"
export * from "./RemoteSearch.vue?vue&type=script&lang=js&"
import style0 from "./RemoteSearch.vue?vue&type=style&index=0&id=7bb350cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb350cc",
  null
  
)

export default component.exports